/*
 Copyright (c) 2025. BrightNight. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited.
 Proprietary and confidential.
 */

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlinedIcon from '@mui/icons-material/Error';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { alpha, type Theme } from '@mui/material';
import { green, grey } from '@mui/material/colors';
import { FlowRunState, type FlowRunStatus } from '@poweralpha/common';
import RunningIcon from '../icons/icon-sport-runner.svg?react';
import { Emoji } from '../react-components/Emoji';

export { flowNameToLogURL, serviceNameToResultURL } from './routes';

export const RUN_ENTRY_HEIGHT = 55;

export const PAGE_SIZE = 10;

export const isFlowRunning = (run: FlowRunStatus) =>
  [FlowRunState.SCHEDULED, FlowRunState.PENDING, FlowRunState.RUNNING].includes(run.state.type);

export const getRunStyling = (theme: Theme, run: FlowRunStatus) => {
  const { state } = run;
  let color: string;
  let icon: React.ReactNode;
  switch (state.type) {
    case FlowRunState.COMPLETED:
      color = theme.palette.success.main;
      icon = <CheckCircleIcon style={{ fontSize: 16, marginRight: 0, color: green[500] }} />;
      break;
    case FlowRunState.CRASHED:
    case FlowRunState.FAILED:
      color = theme.palette.error.main;
      icon = (
        <ErrorOutlinedIcon
          color="error"
          fontSize="inherit"
          style={{ fontSize: 16, marginRight: 0 }}
        />
      );
      break;
    case FlowRunState.PENDING:
    case FlowRunState.RUNNING:
      color = theme.palette.info.main;
      icon = <RunningIcon height={16} style={{ marginRight: 0 }} />;
      break;
    case FlowRunState.CANCELLING:
    case FlowRunState.CANCELLED:
      color = theme.palette.divider;
      icon = (
        <ErrorOutlinedIcon
          color="error"
          fontSize="inherit"
          style={{ fontSize: 16, marginRight: 0, color: grey[500] }}
        />
      );
      break;
    case FlowRunState.PAUSED:
    case FlowRunState.SCHEDULED:
      icon = <ScheduleIcon style={{ fontSize: 16, marginRight: 0, color: grey[500] }} />;
      color = theme.palette.divider;
      break;
    default:
      color = theme.palette.primary.main;
      icon = <Emoji symbol="❓" fontSize={12} />;
  }

  const baseSx = {
    p: 1,
    pr: 2,
    pl: 2,
    position: 'relative',
    height: RUN_ENTRY_HEIGHT,
    cursor: 'default',
  };

  return {
    baseSx,
    clickableSx: {
      ...baseSx,
      cursor: 'pointer',
      '&:hover .run-arrow': {
        opacity: 1,
      },
      '&:hover': {
        backgroundColor: alpha(color, 0.2),
      },
    },
    icon,
  };
};
